// Kleur-dropdown op de productpagina (product-variant-picker, instelling Kleurkeuze).
// De lijst zet de verborgen radio en vuurt 'change' af, zodat variant-selects alles wisselt zoals altijd.
// Alles via event delegation: de kiezer wordt na elke variantwissel opnieuw gerenderd.
(function () {
  function delen(el) {
    var dd = el.closest('[data-mb-kleurdd]');
    if (!dd) return null;
    return { dd: dd, knop: dd.querySelector('.mb-kleurdd__knop'), lijst: dd.querySelector('.mb-kleurdd__lijst') };
  }

  function opties(lijst) {
    return Array.prototype.slice.call(lijst.querySelectorAll('[role="option"]'));
  }

  function markeer(d, optie) {
    opties(d.lijst).forEach(function (o) { o.classList.toggle('is-actief', o === optie); });
    if (!optie) return d.lijst.removeAttribute('aria-activedescendant');
    d.lijst.setAttribute('aria-activedescendant', optie.id);
    optie.scrollIntoView({ block: 'nearest' });
  }

  function open(d) {
    sluitAlles(d.dd);
    d.lijst.hidden = false;
    d.knop.setAttribute('aria-expanded', 'true');
    d.dd.classList.add('is-open');
    markeer(d, d.lijst.querySelector('[aria-selected="true"]') || opties(d.lijst)[0]);
    d.lijst.focus({ preventScroll: true });
  }

  function sluit(d, focusKnop) {
    if (d.lijst.hidden) return;
    d.lijst.hidden = true;
    d.knop.setAttribute('aria-expanded', 'false');
    d.dd.classList.remove('is-open');
    if (focusKnop) d.knop.focus();
  }

  function sluitAlles(behalve) {
    document.querySelectorAll('[data-mb-kleurdd].is-open').forEach(function (dd) {
      if (dd !== behalve) sluit(delen(dd), false);
    });
  }

  function kies(d, optie) {
    if (!optie || optie.getAttribute('aria-disabled') === 'true') return;
    var waarde = optie.dataset.value;
    var radio = Array.prototype.find.call(d.dd.querySelectorAll('input[type="radio"]'), function (r) {
      return r.value === waarde;
    });
    opties(d.lijst).forEach(function (o) { o.setAttribute('aria-selected', o === optie ? 'true' : 'false'); });
    // Knop meteen bijwerken; de sectie wordt daarna toch opnieuw gerenderd
    var bolKnop = d.knop.querySelector('.swatch');
    var bolOptie = optie.querySelector('.swatch');
    if (bolKnop && bolOptie) bolKnop.replaceWith(bolOptie.cloneNode(true));
    sluit(d, true);
    if (radio && !radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  document.addEventListener('click', function (e) {
    var knop = e.target.closest('.mb-kleurdd__knop');
    if (knop) {
      var d = delen(knop);
      if (d.lijst.hidden) open(d); else sluit(d, false);
      return;
    }
    var optie = e.target.closest('.mb-kleurdd__optie');
    if (optie) return kies(delen(optie), optie);
    if (!e.target.closest('[data-mb-kleurdd]')) sluitAlles(null);
  });

  document.addEventListener('keydown', function (e) {
    var knop = e.target.closest && e.target.closest('.mb-kleurdd__knop');
    if (knop && ['ArrowDown', 'ArrowUp'].indexOf(e.key) > -1) {
      e.preventDefault();
      open(delen(knop));
      return;
    }
    var lijst = e.target.closest && e.target.closest('.mb-kleurdd__lijst');
    if (!lijst) return;
    var d = delen(lijst);
    var alle = opties(lijst);
    var nu = alle.indexOf(lijst.querySelector('.is-actief'));
    switch (e.key) {
      case 'ArrowDown': e.preventDefault(); markeer(d, alle[Math.min(alle.length - 1, nu + 1)]); break;
      case 'ArrowUp': e.preventDefault(); markeer(d, alle[Math.max(0, nu - 1)]); break;
      case 'Home': e.preventDefault(); markeer(d, alle[0]); break;
      case 'End': e.preventDefault(); markeer(d, alle[alle.length - 1]); break;
      case 'Enter':
      case ' ': e.preventDefault(); kies(d, alle[nu]); break;
      case 'Escape': e.preventDefault(); sluit(d, true); break;
      case 'Tab': sluit(d, false); break;
    }
  });

  document.addEventListener('mouseover', function (e) {
    var optie = e.target.closest && e.target.closest('.mb-kleurdd__optie');
    if (optie) markeer(delen(optie), optie);
  });
})();
